import { useQuery } from '@tanstack/react-query'

import {
  VestingDetails,
  VestingDetailsResponse,
} from '~/components/smart-accounts/vesting/types'
import { QUERY_KEYS } from '~/constants/react-query'
import { useServerRequests } from '~/hooks/useRequests'

export const useVestingDetails = (vestingBalanceId: string | undefined) => {
  const { serverGetRequest } = useServerRequests()

  return useQuery<VestingDetails>({
    queryKey: [QUERY_KEYS.VESTING_DETAILS, vestingBalanceId],
    enabled: !!vestingBalanceId,
    queryFn: async () => {
      if (!vestingBalanceId) {
        throw new Error('Vesting balance ID is required')
      }

      const response = await serverGetRequest<VestingDetailsResponse>({
        path: `/api/vesting/details/${vestingBalanceId}`,
      })

      if (!response) {
        throw new Error('Failed to fetch vesting details')
      }

      const details = response.data.details

      return {
        ...details,
        totalAmount: BigInt(details.totalAmount),
        vestedAmount: BigInt(details.vestedAmount),
        claimedAmount: BigInt(details.claimedAmount),
        claimableAmount: BigInt(details.claimableAmount),
      }
    },
  })
}
